(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('ActivityHistory', ActivityHistory);

    ActivityHistory.$inject = ['$resource', 'DateUtils'];

    function ActivityHistory ($resource, DateUtils) {
        var resourceUrl =  'api/activity-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actDate = DateUtils.convertLocalDateFromServer(data.actDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.actDate = DateUtils.convertLocalDateToServer(data.actDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.actDate = DateUtils.convertLocalDateToServer(data.actDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
